export default {
  loading: false,
};